namespace Matrix.Rebalancer {
    export namespace HoldingWhitelistService {
        export const baseUrl = 'Rebalancer/HoldingWhitelist';

        export declare function Create(request: Serenity.SaveRequest<HoldingWhitelistRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<HoldingWhitelistRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<HoldingWhitelistRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<HoldingWhitelistRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Rebalancer/HoldingWhitelist/Create",
            Update = "Rebalancer/HoldingWhitelist/Update",
            Delete = "Rebalancer/HoldingWhitelist/Delete",
            Retrieve = "Rebalancer/HoldingWhitelist/Retrieve",
            List = "Rebalancer/HoldingWhitelist/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>HoldingWhitelistService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
